var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLouti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4120_6144)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4120_6144)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 4,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    transform: "matrix(-1 0 0 1 11 4)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 4,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    transform: "matrix(-1 0 0 1 10 3)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 4,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    transform: "matrix(-1 0 0 1 9 2)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 4,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    transform: "matrix(-1 0 0 1 8 1)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 4,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    transform: "matrix(-1 0 0 1 7 0)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 4,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 4,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 4,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 4,
    height: 1,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 4,
    height: 1,
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4120_6144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4120_6144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLouti);
export default __webpack_public_path__ + "static/media/louti.98f9fadd264d3172583acd174b297055.svg";
export { ForwardRef as ReactComponent };